import { Component } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'lib-new-app-version-notification',
  templateUrl: './new-app-version-notification.component.html',
  styleUrls: ['./new-app-version-notification.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    // Material design
    MatButtonModule,
  ],
})
export class NewAppVersionNotificationComponent {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<NewAppVersionNotificationComponent>
  ) {}

  public reload(): void {
    window.location.reload();
    this.bottomSheetRef.dismiss();
  }
}
